import React, { FC } from 'react'
import Button, { IUIButtonProps } from './Button'
import cx from 'classnames'
import css from './button.module.scss'

const GhostButton: FC<React.PropsWithChildren<IUIButtonProps>> = ({ className, ...props }) => {
  return <Button ghost={false} className={cx(css.ghost_button, className)} {...props} />
}

export default GhostButton
